﻿import gsap from "gsap";
import LocomotiveScroll from 'locomotive-scroll';

import Vlitejs from 'vlitejs';
import VlitejsYoutube from 'vlitejs/providers/youtube.js';
Vlitejs.registerProvider('youtube', VlitejsYoutube);

import ClipboardJS from "clipboard";
import Swiper from 'swiper/bundle';

import WindowUtils from './utils/WindowUtils';
import Utils from "./utils/Utils";
import IsInView from "./utils/IsInView";

// import type8GridDebug from "@jeremyfagis/type8-grid-debug";
import type8Credits from "@jeremyfagis/type8-credits";
import * as CookieConsent from "vanilla-cookieconsent";
import CookieConsentConfig from "./utils/cookieconsent-config";


CookieConsent.run(CookieConsentConfig);
document.documentElement.classList.add('cc--darkmode');

// new type8GridDebug(14,0);

const WU = new WindowUtils();

let scroll;

const createScroll = (parent = document) => {
    scroll = new LocomotiveScroll();
    scroll.lenisInstance.options.content.addEventListener('wheel', (event) => {
        const paths = event.composedPath();
    
        paths.find((el) => {
            if(el instanceof HTMLElement && el?.getAttribute('class') == ('pm__body')) {
                event.stopPropagation();
    
                return;
            }
        })
    });
    setTimeout(() => {
        scroll.stop();
    }, 200);
};

const scrollTop = (force) => {
    if (!scroll) return;
    if (force) {
        scroll.scrollTo(0, { immediate: true });
    } else {
        scroll.scrollTo(0, { duration: 1, easing: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x) });
    }
};

const scrollTo = (elt) => {
    scroll.scrollTo(elt, { duration: 1, easing: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x) });
};

window.addEventListener('stickyProgress', (e) => {
    const { target, progress } = e.detail;
    let section = target.closest('.pSection');
    if (section.querySelectorAll('.titleSticky')) {
        gsap.set(section.querySelectorAll('.titleSticky'), { opacity: 1 - progress, scale: 1 - (0.1 * progress) });
    }
});

window.addEventListener('coversProgress', (e) => {
    const { target, progress } = e.detail;
    gsap.set(target, { scale: 0.2 + (0.8 * progress) });
});

window.addEventListener('toggleVideo', (e) => {
    const { target, way, from } = e.detail;
    if (way == 'enter') {
        target.play();
    } else {
        target.pause();
    }
});
window.addEventListener('pauseAudio', (e) => {
    const { target, way, from } = e.detail;
    if (way == 'leave') {
        document.querySelector('.aboutAudio').pause();
        document.querySelectorAll('.aboutAudioToggle').forEach((item) => {
            item.innerHTML = item.getAttribute('data-default');
        });
    }
});
window.addEventListener('pauseAudioIntro', (e) => {
    const { target, way, from } = e.detail;
    if (way == 'leave') {
        document.querySelector('.header_audio').pause();
        document.querySelector('.header_cursor').innerHTML = document.querySelector('.header_cursor').getAttribute('data-default');
        document.querySelector('.header_buttonMobile').innerHTML = document.querySelector('.header_buttonMobile').getAttribute('data-default');
        document.documentElement.removeAttribute("data-hide-nav");
    } else {
        document.documentElement.setAttribute("data-hide-nav", "");
    }
});


/////////////////////////////////
// CLIPS ////////////////////////
/////////////////////////////////

let videoPlayers = [];
let currentClip = null;
let clipsInterval = null;

const getPlayer = (id) => {
    let player = videoPlayers.find(p => p.id === id);

    return player ? player : initPlayer(id);
};

const getSectionProgress = (id = null) => {
    if (id) {
        return document.querySelector('.clips_progress_section[data-clip="' + id + '"]').querySelector('.clips_progress_section_inner');
    } else {
        return document.querySelector('.clips_progress_section.active').querySelector('.clips_progress_section_inner');
    }
};

const setProgress = (elt, value) => {
    gsap.set(elt, { scaleX: value });
};

const playerReady = (id) => {
    let player = getPlayer(id);
    let playerIndex = videoPlayers.findIndex(p => p.id === id);

    if (playerIndex >= 0) {
        videoPlayers[playerIndex].init = true;
    }

    player.player.getDuration().then((data) => {
        videoPlayers[playerIndex].duration = data;
    });

    if (currentClip.id == id) {
        player.player.play();
    }
};

const nextClip = () => {
    if (document.querySelector('.clips_progress_section.active')) {
        let index = parseInt(document.querySelector('.clips_progress_section.active').getAttribute('data-index'));
        let max = document.querySelectorAll('.clips_progress_section').length;
        setProgress(getSectionProgress(), 0);

        let newIndex = (index < (max - 1)) ? (index + 1) : 0;
        let newSection = document.querySelector('.clips_progress_section[data-index="' + newIndex + '"]');
        playClip(newSection.getAttribute('data-clip'));
    }
};

const showEnd = () => {
    document.querySelector('.clip.active').querySelector('.clip_end').classList.add('visible');
    setProgress(getSectionProgress(), 1);
};

const playClip = (clipId) => {

    currentClip = getPlayer(clipId);

    if (currentClip.init) {
        currentClip.player.play();
    }

    if (document.querySelector('.clip.active')){
        document.querySelector('.clip.active').classList.remove('active');
    }
    if (document.querySelector('.clip_end.visible')){
        document.querySelector('.clip_end.visible').classList.remove('visible');
    }
    if (document.querySelector('.clips_progress_section.active')) {
        document.querySelector('.clips_progress_section.active').classList.remove('active');
    }
    document.querySelector('.clip[data-clip="' + clipId + '"]').classList.add('active');
    let currentSection = document.querySelector('.clips_progress_section[data-clip="' + clipId + '"]');
    let currentSectionInner = currentSection.querySelector('.clips_progress_section_inner');
    currentSection.classList.add('active');

    if (clipsInterval) {
        clearInterval(clipsInterval);
    }

    clipsInterval = setInterval(() => {
        currentClip.player.getCurrentTime().then((data) => {
            setProgress(currentSectionInner, (data / currentClip.duration));
        })
    }, 500);
};

const initPlayer = (id) => {
    let elt = document.querySelector('.clip_player[data-youtube-id="' + id + '"]');
    let vp = new Vlitejs(elt, {
        options: {
            controls: false,
            autoplay: false,
            playPause: false,
            bigPlay: false,
            playsinline: true,
            loop: false,
            autoHide: true
        },
        provider: ["youtube"],
        onReady: function (player) {
            playerReady(id);
            player.on("ended", () => {
                // nextClip();
                showEnd();
            });
        },
    });

    let data = { id: id, player: vp.player, init: false, duration: null };
    videoPlayers.push(data);

    return data;
};

document.querySelectorAll('[data-open-clip]').forEach((elt) => {
    elt.addEventListener('click', () => {
        document.querySelector('.clips').classList.add('visible');
        
        let clipId = elt.getAttribute('data-open-clip');
        playClip(clipId);
    })
});

document.querySelectorAll('.clips_progress_section_button').forEach((button) => {
    button.addEventListener('click', (e) => {
        let elt = button.closest('.clips_progress_section');
        if (elt.classList.contains('active')){
            const target = button;
            const rect = target.getBoundingClientRect();
            const pct = (e.clientX - rect.left) / rect.width;
            
            setProgress(getSectionProgress(), pct);
            currentClip.player.seekTo(Math.round(currentClip.duration * pct));
            
        } else {
            currentClip.player.pause();
            currentClip.player.seekTo(0);
            setProgress(getSectionProgress(), 0);
            clearInterval(clipsInterval);

            let clipId = elt.getAttribute('data-clip');
            playClip(clipId);
        }
    })
});

document.querySelectorAll('.clip_restart').forEach((elt) => {
    elt.addEventListener('click', () => {
        currentClip.player.seekTo(0);
        currentClip.player.pause();
        setProgress(getSectionProgress(), 0);
        playClip(currentClip.id);
    })
});

if (document.querySelector('.clips_close')) {
    document.querySelector('.clips_close').addEventListener('click', () => {
        document.querySelector('.clips').classList.remove('visible');

        currentClip.player.pause();
        currentClip.player.seekTo(0);
        setProgress(getSectionProgress(), 0);
        clearInterval(clipsInterval);

        if (document.querySelector('.clip.active')){
            document.querySelector('.clip.active').classList.remove('active');
        }
        if (document.querySelector('.clips_progress_section.active')) {
            document.querySelector('.clips_progress_section.active').classList.remove('active');
        }
    });
}








const openPopin = (id) => {
    const popinsWrap = document.querySelector('.popins');
    const popin = popinsWrap.querySelector('.popin[data-popin="' + id + '"]');
    scroll.stop();
    popinsWrap.classList.add('visible');
    popin.classList.add('visible');
    popin.querySelector('.popin_scroller').scrollTop = 0;

    gsap.fromTo(
        popin.querySelector('.popin_background'),
        { y: '101%'  },
        { y: '0%', duration: 0.8, ease: 'expo.inOut' }
    );
    gsap.fromTo(
        popin.querySelector('.popin_title'),
        { y: 60, opacity: 0  },
        { y: 0, opacity: 1, duration: 1, ease: 'expo.out', delay: 0.7 }
    );

    if (popin.querySelector('.popin_additional')) {
        gsap.fromTo(
            popin.querySelector('.popin_additional'),
            { y: 60, opacity: 0  },
            { y: 0, opacity: 1, duration: 0.8, ease: 'expo.out', delay: 0.85 }
        );

    }

    gsap.fromTo(
        popin.querySelector('.popin_content'),
        { y: "80vh" },
        { y: 0, duration: 0.8, ease: 'expo.out', delay: (popin.querySelector('.popin_additional')) ? 0.9 : 0.6 }
    );

    

    let popinClose = popin.querySelector('.popin_close');
    let cursor = popinClose.querySelector('.button');
    let bounds = popinClose.getBoundingClientRect();
    cursor.style.transform = 'translate(' + (bounds.width/2) + 'px,' + (bounds.height/2) + 'px)';

    popinClose.addEventListener('mousemove', e => {
        cursor.style.transform = 'translate(' + (e.clientX - bounds.left) + 'px,' + (e.clientY - bounds.top) + 'px)';
    });
    
    popinClose.addEventListener('mouseenter', (e) => {
        // cursor.classList.add('visible');
    });

    popinClose.addEventListener('mouseleave', () => {
        // cursor.classList.remove('visible');
        cursor.style.transform = 'translate(' + (bounds.width/2) + 'px,' + (bounds.height/2) + 'px)';
    });

};

const closePopin = () => {

    gsap.to(document.querySelector('.popin.visible'),
        {
            y: "100vh",
            duration: 0.8,
            ease: 'expo.out',
            onComplete: () => {
                gsap.set(document.querySelector('.popin.visible'), { y: 0 });
                document.querySelector('.popins').classList.remove('visible');
                document.querySelector('.popin.visible').classList.remove('visible');
                scroll.start();
            }
        }
    );
};

const activeArchive = (id) => {
    const cover = document.querySelector('.archives_items_cover[data-archive="' + id + '"]');
    const label = document.querySelector('.archives_item[data-archive="' + id + '"]');

    document.querySelector('.archives_items_cover.active').classList.remove('active');
    document.querySelector('.archives_item.active').classList.remove('active');

    cover.classList.add('active');
    label.classList.add('active');
};

const activeArchiveMobile = (id) => {
    const cover = document.querySelector('.archives_items_cover[data-archive="' + id + '"]');
    const label = document.querySelector('.archives_itemMobile[data-archive="' + id + '"]');

    document.querySelector('.archives_items_cover.active').classList.remove('active');
    document.querySelector('.archives_itemMobile.active').classList.remove('active');

    cover.classList.add('active');
    label.classList.add('active');
};

const initTextElements = () => {
    const elements = document.querySelectorAll('.text-surround, .text-underline-light, .text-underline-heavy, .text-strike, .text-heart');
    elements.forEach((elt) => {
        elt.setAttribute('data-iiv', '');
    })
};

const initIntroCursor = () => {
    let toggle = document.querySelector('.header_toggle');
    let cursor = document.querySelector('.header_cursor');
    let audio = document.querySelector('.header_audio');
    let toggleMobile = document.querySelector('.header_buttonMobile');

    toggle.addEventListener('click', () => {
        if (audio.paused){
            audio.play();
        } else {
            audio.pause();
        }
        cursor.innerHTML = audio.paused ? 'SON' : 'OFF';
    });

    toggleMobile.addEventListener('click', () => {
        if (audio.paused){
            audio.play();
        } else {
            audio.pause();
        }
        toggleMobile.innerHTML = audio.paused ? 'SON' : 'OFF';
    });
    
    toggle.addEventListener('mousemove', e => {
        let bounds = toggle.getBoundingClientRect();
        cursor.style.transform = 'translate(' + (e.clientX - bounds.left) + 'px,' + (e.clientY - bounds.top) + 'px)';
    });
    
    toggle.addEventListener('mouseenter', (e) => {
        cursor.classList.add('visible');
    });

    toggle.addEventListener('mouseleave', () => {
        cursor.classList.remove('visible');
    });
    
};

const initAboutAudio = () => {
    let audio = document.querySelector('.aboutAudio');

    document.querySelectorAll('.aboutAudioToggle').forEach((toggle) => {
        if (!audio || !toggle) return;
    
        toggle.addEventListener('click', () => {
            if (audio.paused) {
                audio.play();
                toggle.innerHTML = toggle.getAttribute('data-pause');
            } else {
                audio.pause();
                toggle.innerHTML = toggle.getAttribute('data-default');
            }
        });
    });
};

const initMenu = () => {
    const toggle = document.querySelector('.menuToggle');
    const menu = document.querySelector('.menu');
    const background = document.querySelector('.menu_background');

    toggle.addEventListener('click', (e) => {
        e.preventDefault();
        menu.classList.toggle('opened');
        toggle.classList.toggle('active');

        if (toggle.classList.contains('active')){
            scroll.stop();
        } else {
            scroll.start();
        }
    });

    background.addEventListener('click', (e) => {
        menu.classList.remove('opened');
        toggle.classList.remove('active');
        scroll.start();
    });

    menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            let anchor = link.getAttribute('href');
            window.location.hash = anchor;
            anchor = anchor.slice(1);
            let section = document.querySelector('[data-anchor="' + anchor + '"]');

            menu.classList.remove('opened');
            toggle.classList.remove('active');
            scroll.start();

            setTimeout(() => {
                scrollTo(section);
            }, 200);
        });
    });

};

const initVideosCursors = () => {
    let coversButtonWrap = document.querySelectorAll('.videoItem_cover_button');

    if (coversButtonWrap.length == 0) return;
    
    coversButtonWrap.forEach((item) => {
        let cursor = item.querySelector('.button');
        let bounds = item.getBoundingClientRect();
        cursor.style.transform = 'translate(' + (bounds.width/2) + 'px,' + (bounds.height - 40 - WU.w.h * 0.06) + 'px)';
    
        item.addEventListener('mousemove', e => {
            let bounds = item.getBoundingClientRect();
            cursor.style.transform = 'translate(' + (e.clientX - bounds.left) + 'px,' + (e.clientY - bounds.top) + 'px)';
        });
        
        item.addEventListener('mouseenter', (e) => {
        });
    
        item.addEventListener('mouseleave', () => {
            let bounds = item.getBoundingClientRect();
            cursor.style.transform = 'translate(' + (bounds.width/2) + 'px,' + (bounds.height - 40 - WU.w.h * 0.06) + 'px)';
        });
    });
};

const initCollapses = () => {
    if (document.querySelectorAll('[data-collapse]')) {
        document.querySelectorAll('[data-collapse]').forEach((collapse) => {
            let collapseToggle = collapse.querySelector('[data-collapse-toggle]');
            let collapseContent = collapse.querySelector('[data-collapse-content]');
            collapseToggle.addEventListener('click', (e) => {
                let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                collapse.toggleAttribute('data-collapse-opened');
                gsap.to(collapseContent, {
                    height: collapse.hasAttribute('data-collapse-opened') ? contentHeight : 0,
                    ease: "expo.out",
                    duration: 0.8,
                    onComplete: () => { scroll.resize(); }
                });

                if (collapse.getAttribute('data-collapse-scrollto') && collapse.hasAttribute('data-collapse-opened')) {
                    let offset = collapse.getAttribute('data-collapse-scrollto') ? collapse.getAttribute('data-collapse-scrollto') : 0;
                    scrollTo(collapseToggle, offset);
                }
            });

            if (collapse.hasAttribute('data-collapse-opened-force')) {
                collapse.setAttribute('data-collapse-opened', '');
                let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                collapseContent.style.height = contentHeight + 'px';
                collapse.removeAttribute('data-collapse-opened-force');
            }
        });

        const resizeCollapsesContents = () => {
            if (document.querySelectorAll('[data-collapse-opened]')) {
                document.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
                    let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                    collapse.querySelector('[data-collapse-content]').style.height = contentHeight + 'px';
                });
            }
        };

        window.addEventListener('resize', Utils.debounce(() => { resizeCollapsesContents() }), { passive: true });
    }
};

const page = () => {
    
    new type8Credits('.type8_open a');

    setTimeout(() => {
        scroll.resize();
    }, 1000);

    initMenu();

    initTextElements();
    new IsInView();

    initIntroCursor();
    initAboutAudio();
    initVideosCursors();

    initCollapses();
    
    document.querySelectorAll('[data-clipboard-text]').forEach((elt) => {
        let clipboard = new ClipboardJS(elt);
        clipboard.on('success', function(e) {
            elt.closest('.shareWrap').classList.add('copied');

            setTimeout(() => {
                elt.closest('.shareWrap').classList.remove('copied');
            }, 3000);
        
            e.clearSelection();
        });
    });

    // POPINS
    document.querySelectorAll('a[data-popin]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            openPopin(link.getAttribute('data-popin'));
        })
    });
    document.querySelectorAll('.popin_close').forEach((elt) => {
        elt.addEventListener('click', (e) => {
            closePopin();
        });
    });
    document.querySelectorAll('.popin_closeMobile').forEach((elt) => {
        elt.addEventListener('click', (e) => {
            closePopin();
        });
    });

    document.querySelectorAll('.archives_item').forEach((elt) => {
        elt.addEventListener('mouseenter', (e) => {
            if (!elt.classList.contains('active')) {
                activeArchive(elt.getAttribute('data-archive'));
            }
        });
    });

    document.querySelectorAll('.archives_itemMobile_label').forEach((elt) => {
        elt.addEventListener('click', (e) => {
            if (!elt.closest('.archives_itemMobile').classList.contains('active')) {
                activeArchiveMobile(elt.closest('.archives_itemMobile').getAttribute('data-archive'));
            }
        });
    });

    document.querySelector('.logo').addEventListener('click', () => {
        scrollTop();
    });

    if (document.querySelector('.videoItemsCarousel')) {
        let swiper = new Swiper(document.querySelector('.videoItemsCarousel .swiper'), {
            init: true,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            pagination: {
                el: document.querySelector('.videoItemsCarousel .swiper-pagination'),
                clickable: true
            },
        });
    }

    if (document.querySelector('.galleryMobile')) {
        let swiper = new Swiper(document.querySelector('.galleryMobile .swiper'), {
            init: true,
            slidesPerView: 1,
            spaceBetween: 40,
            loop: true,
            autoHeight: true,
            pagination: {
                el: document.querySelector('.galleryMobile .swiper-pagination'),
                clickable: true
            },
        });
    }

};

const initPage = () => {
    createScroll();
    page();
};

const hideLoading = () => {
    document.querySelector('.loadingScreen').classList.remove('visible');
};

const animateIntro = () => {
    let letters = document.querySelector('.header').querySelectorAll('.letter');
    gsap.to(letters, {
        y: 0,
        opacity: 1,
        stagger: 0.25,
        duration: 0.5,
        ease: "circ.out",
        onComplete: () => {
            setTimeout(() => {
                document.querySelector('.header_content').classList.add('visible');
                document.querySelector('.header_content').querySelectorAll('[data-iiv]').forEach((elt) => {
                    elt.classList.add('is-inview');
                });
            }, 400);
            setTimeout(() => {
                document.querySelector('.header_intro').classList.add('hidden');
                document.querySelector('.header_intro_svg').classList.add('difference');
                scroll.start();

                let hash = window.location.hash;
                if (hash) {
                    hash = hash.slice(1);
                    let section = document.querySelector('[data-anchor="' + hash + '"]');
                    if (section) {
                        setTimeout(() => {
                            scrollTo(section);
                        }, 1000);
                    }
                }
            }, 2000);
        }
    });
};

(function () {

    Utils.preloadHTMLImages(document.body.innerHTML).then(() => {
        initPage();

        setTimeout(() => {
            scroll.start();
            setTimeout(() => {
                scrollTop(true);
                scroll.stop();
            }, 10);
            hideLoading();
            setTimeout(() => {
                animateIntro();
            }, 400);
        }, 600);
    });

})();